export class MagicLinkUnauthorizedError extends Error {
  constructor() {
    super('Magic link is invalid, expired, or already consumed')
    this.name = 'MagicLinkUnauthorizedError'
  }
}
